// Built-in slides for the dashboard banner. Admins manage the real slides on
// the Admin page (Dashboard banner tab), stored in the SharePoint "Featured
// Content" list; these show only while that list is empty or can't be read.
//
// Each item needs a title. Everything else is optional:
// - videoUrl: YouTube, Vimeo or a direct .mp4 link plays in a popup player on
//   the page; any other link opens in a new tab. A YouTube link also supplies
//   the thumbnail when `image` is left out.
// - image: a full URL, or a file placed in /public (e.g. "/featured/copilot.jpg").
// - link: a secondary button (e.g. release notes, or a page on this site).
// Several items rotate with dots; order is the order shown.
import type { Embed } from "../components/VideoPlayer";

export type FeaturedSlide = {
  id: string;
  title: string;
  description?: string;
  /** Small label above the title, e.g. "New release", "Demo", "Webinar". */
  tag?: string;
  /** Shown next to the tag, e.g. "Oct 2026" or "8 min". */
  meta?: string;
  videoUrl?: string;
  image?: string;
  link?: { label: string; url: string };
  /** How to play videoUrl when it isn't a plain YouTube/Vimeo/.mp4 link
   *  (SharePoint videos); null opens it in a new tab instead. */
  player?: Embed | null;
  /** No media: the screen shows the title and description instead. */
  textOnly?: boolean;
};

export const FEATURED_SLIDES: FeaturedSlide[] = [
  {
    id: "scout-demo",
    tag: "Demo",
    meta: "1 min",
    title: "Scout: competitive market analysis",
    description:
      "A quick tour for viewers and editors: see your market at a glance, filter everything at once, open any listing and build your own report.",
    videoUrl: "/featured/scout-demo.mp4",
    image: "/featured/scout-demo.jpg",
  },
];
